// extracted by mini-css-extract-plugin
module.exports = {"container":"PersonScreen_container__oDfJj","person":"PersonScreen_person__6jM5e","title":"PersonScreen_title__y222u","noResults":"PersonScreen_noResults__WRt4b"};